import PratusSelect from 'components/DesignSystems/New/PratusSelect';

const statusOptions = [
  { value: 'draft', label: 'Draft' },
  { value: 'awaiting_approval', label: 'Section Chief Review' },
  { value: 'awaiting_review', label: 'RESL Review' },
  { value: 'awaiting_order', label: 'Logistics Order' },
  { value: 'awaiting_payment', label: 'Finance Payment' },
  { value: 'awaiting_incident_commander', label: 'Incident Commander Approval' },
  { value: 'awaiting_final', label: 'Final Approval' },
  { value: 'completed', label: 'Approved' },
];

export const RequestHeaderCard = ({
  setStatusFilter,
}: {
  setStatusFilter: (status: string[]) => void;
}) => {
  return (
    <div className="resource-header request-grid p-2 align-items-top">
      <div>{/* Intentionally empty for css grid spacing */}</div>
      <div>Request Name</div>
      <div>Submitted By</div>
      <div>
        Status
        <div className="me-2">
          <PratusSelect
            options={statusOptions}
            onChange={(selectedOptions) => {
              setStatusFilter(
                selectedOptions
                  ? (selectedOptions as { value: string; label: string }[]).map(
                      (option) => option.value
                    )
                  : []
              );
            }}
            isMulti
          />
        </div>
      </div>
      <div>Resources</div>
      <div>Actions</div>
    </div>
  );
};
